import type { RootState } from "@/app/store/store";
import CheckOutlineIcon from "@rsuite/icons/CheckOutline";
import ReloadIcon from "@rsuite/icons/Reload";
import React from "react";
import { useSelector } from "react-redux";
import type { PersistPartial } from "redux-persist/es/persistReducer";
import { ButtonToolbar, IconButton } from "rsuite";
import { useUncompleteActivityMutation } from "../../../entities/Activity/activityApi";

type ToolBarProps = {
	activityId?: string;
	reset: () => void;
	checkAnswer: () => Promise<boolean>;
};

const ToolBar = ({ checkAnswer, reset, activityId }: ToolBarProps) => {
	const [uncompleteActivity] = useUncompleteActivityMutation();

	const authStore = useSelector(
		(
			state: RootState &
				PersistPartial & {
					auth: {
						isAuthenticated: boolean;
						user: {
							userId: string;
						};
					};
				},
		) => state?.auth,
	);

	const handleReset = async () => {
		await uncompleteActivity({
			changes: {
				activityId: activityId as string,
				userId: authStore?.user.userId as string,
			},
		});
		reset();
	};

	const handleCheckAnswer = async () => {
		if (checkAnswer) {
			await checkAnswer();
		} else {
			console.log("Some answers are incorrect. Try again!");
		}
	};

	return (
		<div className="container__toolbar">
			<ButtonToolbar>
				<IconButton
					onClick={handleReset}
					appearance="primary"
					icon={<ReloadIcon color="white" />}
				/>
				<IconButton
					onClick={handleCheckAnswer}
					appearance="primary"
					icon={<CheckOutlineIcon color="white" />}
				>
					Check
				</IconButton>
			</ButtonToolbar>
		</div>
	);
};

export default ToolBar;
